export type WalkthroughCue = "click" | "page" | "seal";

let context: AudioContext | null = null;
let activeNodes: OscillatorNode[] = [];

function audioContext(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const AudioContextCtor = window.AudioContext;
  if (!AudioContextCtor) return null;
  context ??= new AudioContextCtor();
  return context;
}

function tone(ctx: AudioContext, frequency: number, start: number, duration: number, gainValue: number) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = "sine";
  oscillator.frequency.setValueAtTime(frequency, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(Math.max(0.0001, gainValue), start + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(start);
  oscillator.stop(start + duration + 0.02);
  activeNodes.push(oscillator);
  oscillator.addEventListener("ended", () => {
    activeNodes = activeNodes.filter((node) => node !== oscillator);
  });
}

export function playWalkthroughCue(cue: WalkthroughCue, volume: number, muted: boolean): void {
  if (muted || volume <= 0) return;
  const ctx = audioContext();
  if (!ctx) return;
  void ctx.resume();
  const level = Math.min(0.035, Math.max(0.006, volume * 0.00035));
  const now = ctx.currentTime;
  if (cue === "click") {
    tone(ctx, 520, now, 0.07, level);
  } else if (cue === "page") {
    tone(ctx, 240, now, 0.12, level * 0.7);
    tone(ctx, 330, now + 0.05, 0.12, level * 0.55);
  } else {
    tone(ctx, 392, now, 0.22, level);
    tone(ctx, 523, now + 0.08, 0.28, level * 0.8);
  }
}

export function stopWalkthroughCues(): void {
  activeNodes.forEach((node) => {
    try { node.stop(); } catch { /* already stopped */ }
  });
  activeNodes = [];
}
